<template>
    <div>
        <div class="sticky-top text-right">

            <template v-if="categoryId > 0">
                <b-button @click="updateCategory"
                          class="btn-round"
                          variant="success">{{$t('saveTitle')}}
                </b-button>
            </template>

            <template v-else>
                <b-button @click="storeCategory"
                          class="btn-round"
                          variant="success">{{$t('saveTitle')}}
                </b-button>
            </template>

        </div>


        <b-card title="Image" v-if="role ==='admin'">
            <b-form-group label="select image" class="required"></b-form-group>

            <template v-if="previewUrl !== null">
                <b-img :src="previewUrl" width="120" alt="placeholder"></b-img>
            </template>
            <b-form-file
                    @change="onSelectFile"
                    v-model="form.image" class="mt-3" plain></b-form-file>
        </b-card>
        <!--Image-->

        <b-card title="information">
            <b-form-group
                    v-if="role ==='admin'"
                    class="required"
                    label="Kategoriename"
                    :state="!validation.hasError('title')"
                    :invalid-feedback="validation.errorTitle('title')"
            >
                <b-input
                        v-model="form.title"></b-input>
            </b-form-group>
            <b-form-group
                    class="required"
                    label="seo url"
                    :state="!validation.hasError('title_seo')"
                    :invalid-feedback="validation.errorTitle('title_seo')"
            >
                <b-input
                        placeholder="lordofhanf.com/"
                        v-model="form.title_seo"></b-input>
            </b-form-group>
        </b-card>
        <!--information-->

        <b-card title="Kategorie page">
            <b-form-group
                    class="required"
                    label="header title"
                    :state="!validation.hasError('subtitle')"
                    :invalid-feedback="validation.errorTitle('subtitle')"
            >
                <b-input
                        v-model="form.subtitle"></b-input>
            </b-form-group>
            <b-form-group
                    class="required"
                    label="top description"
                    :state="!validation.hasError('header')"
                    :invalid-feedback="validation.errorTitle('header')"
            >
                <tinymce id="d1" :other_options="optionsEditor" v-model="form.header"></tinymce>
            </b-form-group>
            <b-form-group
                    class="required"
                    label="description bottom page desktop"
                    :state="!validation.hasError('description')"
                    :invalid-feedback="validation.errorTitle('description')"
            >
                <tinymce id="d2" :other_options="optionsEditor" v-model="form.description"></tinymce>
            </b-form-group>
            <b-form-group
                    class="required"
                    label="description bottom page mobile"
                    :state="!validation.hasError('descriptionMobile')"
                    :invalid-feedback="validation.errorTitle('descriptionMobile')"
            >
                <tinymce id="d3" :other_options="optionsEditor" v-model="form.descriptionMobile"></tinymce>
            </b-form-group>
        </b-card>
        <!--END Description-->

        <b-card title="Google SEO">
            <b-form-group
                    label="meta description"
                    :state="!validation.hasError('seocontent')"
                    :invalid-feedback="validation.errorTitle('seocontent')"
            >
                <tinymce id="d10" :other_options="optionsEditor" v-model="form.seocontent"></tinymce>
            </b-form-group>
            <b-form-group
                    label="meta title"
            >
                <b-input v-model="form.meta_title"></b-input>
            </b-form-group>
        </b-card>

        <b-card title="Options" v-if="role ==='admin'">
            <b-form-checkbox
                    id="checkbox-1"
                    name="checkbox-1"
                    v-model="form.is_hidden"
            >
                Kategorie nicht anzeigen?
            </b-form-checkbox>
            <b-form-checkbox
                    id="checkbox-2"
                    name="checkbox-2"
                    v-model="form.is_offer"
            >
                Kategorie is Angebot?
            </b-form-checkbox>
            <b-form-checkbox
                    id="checkbox-4"
                    name="checkbox-4"
                    v-model="form.is_category_new"
            >
                is neu?
            </b-form-checkbox>

        </b-card>
    </div>
</template>

<script>
    import Http from '../../Services/HttpService/HttpService'
    import Notification from '../../Services/Notification/Nottification'
    import Validation from '../../Services/Validation/Validation'
    import {EventBus} from "../../Services/Eventbus/event-bus";

    export default {
        name: "Form",
        props: {
            parentCategoryId: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                previewUrl: null,
                role: null,
                categoryId: 0,
                validation: new Validation(),
                optionsEditor: {
                    height: 300,
                    toolbar: [
                        'formatselect | fontsizeselect | fontselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | removeformat'
                    ]
                },
                form: {
                    title: '',
                    meta_title: null,
                    title_seo: '',
                    header: '',
                    subtitle: '',
                    order: 0,
                    description: '',
                    descriptionMobile: '',
                    seocontent: '',
                    is_hidden: false,
                    is_offer: false,
                    image: null,
                    is_category_new: false,
                }
            }
        },
        methods: {
            onSelectFile(event) {
                this.previewUrl = URL.createObjectURL(event.target.files[0]);
            },
            storeCategory() {
                let fd = new FormData();
                fd.append('category_parent', this.parentCategoryId);
                fd.append('title', this.form.title);
                fd.append('meta_title', this.form.meta_title);
                fd.append('title_seo', this.form.title_seo);
                fd.append('header', this.form.header);
                fd.append('subtitle', this.form.subtitle);
                fd.append('order', this.form.order);
                fd.append('description', this.form.description);
                fd.append('descriptionMobile', this.form.descriptionMobile);
                fd.append('seocontent', this.form.seocontent);
                fd.append('is_hidden', this.form.is_hidden);
                fd.append('is_offer', this.form.is_offer);
                fd.append('is_category_new', this.form.is_category_new);
                fd.append('image', this.form.image);

                this.$Progress.start();

                Http.post(Http.apiurlV2() + 'subcategory/store', fd)
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.created()) {

                            Notification.success(response.data.message);
                            location.reload();
                        } else {
                            Notification.error(response.data.message);

                            this.validation.store(response.data.data);
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })

            },
            updateCategory() {
                let fd = new FormData();
                fd.append('title', this.form.title);
                fd.append('meta_title', this.form.meta_title);
                fd.append('title_seo', this.form.title_seo);
                fd.append('header', this.form.header);
                fd.append('subtitle', this.form.subtitle);
                fd.append('order', this.form.order);
                fd.append('description', this.form.description);
                fd.append('descriptionMobile', this.form.descriptionMobile);
                fd.append('seocontent', this.form.seocontent);
                fd.append('is_hidden', this.form.is_hidden);
                fd.append('is_offer', this.form.is_offer);
                fd.append('is_category_new', this.form.is_category_new);
                if (this.form.image !== null) {
                    fd.append('image', this.form.image);
                }

                this.$Progress.start();

                Http.post(Http.apiurlV2() + 'subcategory/update/' + this.categoryId, fd)
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            Notification.success(response.data.message);
                            EventBus.$emit("updateSubcategorySuccess", "yes");
                            this.categoryId = 0;
                        } else {
                            Notification.error(response.data.message);

                            this.validation.store(response.data.data);
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })

            },
            detailsCategory(categoryId) {
                this.$Progress.start();
                Http.get(Http.apiurlV2() + 'subcategory/show/' + categoryId)
                    .then(response => {
                        if (response.data.status_code === Http.ok()) {
                            this.$Progress.finish();
                            let data = response.data.data;
                            this.form.title = data.category_title;
                            this.form.meta_title = data.category_meta_title;
                            this.form.title_seo = data.category_title_url;
                            this.form.header = data.category_header;
                            this.form.subtitle = data.category_subtitle;
                            this.form.description = data.category_desc;
                            this.form.descriptionMobile = data.category_desc_mobile;
                            this.form.seocontent = data.category_content_seo;
                            this.previewUrl = data.category_image_url;
                            if (data.category_is_hidden === 'yes') {
                                this.form.is_hidden = true;
                            }
                            if (data.category_is_offer === 'yes') {
                                this.form.is_offer = true;
                            }
                            if (data.category_is_new === 'yes') {
                                this.form.is_category_new = true;
                            }

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            }
        },
        created() {
            let myThis = this;
            EventBus.$on('updateSubcategory', function (payload) {
                myThis.categoryId = payload.id;
                myThis.detailsCategory(payload.id);
            });
        },
        mounted() {
            this.role = localStorage.getItem('role');
        }
    }
</script>

<style scoped>

</style>